import rendementApi from '@/api/rendement.api'

const getDefaultState = () => {
  return {
    rendementNumtiers: [],
    evolutionRendementNumtiers: {},
    rendementGroupe: [],
    repartitionRendementGroupe: [],
    grapheComparaisonRendementGroupe: {}
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    rendementNumtiers (state) {
      return state.rendementNumtiers
    },
    evolutionRendementNumtiers (state) {
      return state.evolutionRendementNumtiers
    },
    rendementGroupe (state) {
      return state.rendementGroupe
    },
    repartitionRendementGroupe (state) {
      return state.repartitionRendementGroupe
    },
    grapheComparaisonRendementGroupe (state) {
      return state.grapheComparaisonRendementGroupe
    },
  },

  mutations: {
    UPDATE_RENDEMENT_NUMTIERS (state, rendementNumtiers) {
      state.rendementNumtiers = rendementNumtiers
    },
    UPDATE_EVOLUTION_RENDEMENT_NUMTIERS (state, evolutionRendementNumtiers) {
      state.evolutionRendementNumtiers = evolutionRendementNumtiers
    },
    UPDATE_RENDEMENT_GROUPE (state, rendementGroupe) {
      state.rendementGroupe = rendementGroupe
    },
    UPDATE_REPARTITION_RENDEMENT_GROUPE (state, repartitionRendementGroupe) {
      state.repartitionRendementGroupe = repartitionRendementGroupe
    },
    UPDATE_GRAPHE_COMPARAISON_RENDEMENT_GROUPE (state, grapheComparaisonRendementGroupe) {
      state.grapheComparaisonRendementGroupe = grapheComparaisonRendementGroupe
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getRendementsByNumtiersAndRecolteAndGraine ({ commit, rootGetters }, codeGraine) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return rendementApi.getRendementsByNumtiersAndRecolteAndGraine(username, anneeRecolte, codeGraine)
        .then(response => {
          commit('UPDATE_RENDEMENT_NUMTIERS', response)
        })
    },
    getRendementsByNumtiersAndRecolteAndGraineGroupe ({ commit, rootGetters }, codeGraine) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return rendementApi.getRendementsByNumtiersAndRecolteAndGraineGroupe(username, anneeRecolte, codeGraine, filtres)
        .then(response => {
          commit('UPDATE_RENDEMENT_GROUPE', response)
        })
    },
    getEvolutionRendement ({ commit, rootGetters }, codeGraine) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return rendementApi.getEvolutionRendement(username, anneeRecolte, codeGraine)
        .then(response => {
          commit('UPDATE_EVOLUTION_RENDEMENT_NUMTIERS', response)
        })
    },

    getResumeRepartitionParQuartileRendementGroupe ({ commit, rootGetters }, codeGraine) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return rendementApi.getResumeRepartitionParQuartileRendementGroupe(username, anneeRecolte, codeGraine, filtres)
        .then(response => {
          commit('UPDATE_REPARTITION_RENDEMENT_GROUPE', response)
        })
    },
    getGrapheComparaisonCultureRendementMoyens ({ commit, rootGetters }, codeGraine) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return rendementApi.getGrapheComparaisonCultureRendementMoyens(username, anneeRecolte, codeGraine, filtres)
        .then(response => {
          commit('UPDATE_GRAPHE_COMPARAISON_RENDEMENT_GROUPE', response)
        })
    },

    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
